export const EmailReportGridColumnName = {
    CandidateName: "Candidate name",
    ClientName: "Contact name",
    Email: "Email",
    EmailName: "Email name",
    BouncedDate: "Bounced date",
    OpenDate: "Open date",
    LinkClicked: "Link clicked",
    Delivered: "Delivered",
    LinkTitle: "LinkTitle",
    CampaignName: "Campaign name",
    AutomationName: "Campaign name",
    LinkName: "Link name",
    Url: "Url",
    Clicks: "Clicks",
    Opened: "Opened",
    Click: "Click",
    UnsubscribedDate: "Unsubscribed date",
    LastSentDate: "Last sent date",
    LastSendDate: "Last send date",
    TotalSent: "Total sent",
    Bounced: "Bounced",
    Unsubscribed: "Unsubscribed",
    Clicked: "Clicked",
    SurveyOpened: "Survey opened",
    SurveyClicked: "Survey clicked",
    Processed: "Processed",
    SendDate: "Send date",
    Status: "Status",
    Category: "Category",
    Invalid: "Invalid",
    CandidateFirstName: "Candidate first name",
    CandidateLastName: "Candidate last name",
    ClientFirstName: "Contact first name",
    ClientLastName: "Contact last name",
    JobTitle: "Job title",
    Company: "Company"
};
